import {
  ChevronDown,
  ChevronRight,
  LayoutDashboard,
  LogOut,
  MessageSquare,
  Package,
  Settings,
  ShoppingBag,
  Wallet,
} from "lucide-react";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../assets/css/seller/SellerSideBar/sellerSidebar.css";
import AppContext from "../../../context/AppContext";
import { MdHelpOutline } from "react-icons/md";
import { Container } from "react-bootstrap";
import logo from "../../../assets/images/logo.png";

const SellerSideBar = () => {
  const navigate = useNavigate();
  const { storeSelectedScreenOfSellerDashboardSidebar, setLoggedInSeller } = useContext(AppContext);
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);

  const sidebarItems = [
    { id: "dashboard", path: "/seller-dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { id: "deals", path: "/seller-deals", icon: Package, label: "Deals" },
    { id: "orders", path: "/seller-orders", icon: ShoppingBag, label: "Orders" },
    { id: "wallet", path: "/seller-wallet", icon: Wallet, label: "Wallet" },
    { id: "notifications", path: "/seller-notifications", icon: MessageSquare, label: "Notifications" },
    { id: "supports", path: "/seller-supports", icon: MdHelpOutline, label: "Supports" },
    { id: "settings", path: "/seller-setting", icon: Settings, label: "Settings" },
  ];

  const handleItemClick = (item) => {
    if (item.subItems) {
      setOpenDropdown(openDropdown === item.id ? null : item.id);
      storeSelectedScreenOfSellerDashboardSidebar(item.label);
      navigate(item.path);
    } else {
      setOpenDropdown(null);
      storeSelectedScreenOfSellerDashboardSidebar(item.label);
      navigate(item.path);
    }
  };

  // ✅ CHANGED: sellerToken bhi clear kiya (pehle sirf loggedInSeller/sellerEmail/sellerPassword clear ho rahe thay,
  // token reh jata tha, jisse axios interceptor purana token bhejta rehta)
  const sellerLogout = () => {
    localStorage.removeItem("loggedInSeller");
    localStorage.removeItem("sellerEmail");
    localStorage.removeItem("sellerPassword");
    localStorage.removeItem("sellerToken");
    setLoggedInSeller(null);
    navigate("/seller-login");
  };

  return (
    <Container fluid>
      <aside className="ss-sidebar">
        <div className="ss-sidebar-content">
          {/* Logo Section */}
          <div className="ss-logo-section">
            <div className="ss-logo">
              <img src={logo} alt="Time4Pulse Logo" className="ss-logo-icon" />
            </div>
          </div>

          {/* Menu Items */}
          <nav className="ss-menu">
            {sidebarItems.map((item) => {
              const isActive = location.pathname === item.path;
              const isOpen = openDropdown === item.id;
              return (
                <div key={item.id} className="ss-menu-group">
                  <div
                    className={`ss-menu-item ${isActive ? "ss-active" : ""}`}
                    onClick={() => handleItemClick(item)}
                  >
                    <div className="ss-menu-item-content">
                      <item.icon size={20} className="ss-menu-icon" />
                      <span className="ss-menu-label">{item.label}</span>
                    </div>
                    {item.subItems && (
                      <span className="ss-dropdown-arrow">
                        {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                      </span>
                    )}
                  </div>

                  {/* Submenu */}
                  {item.subItems && isOpen && (
                    <div className="ss-submenu">
                      {item.subItems.map((sub) => {
                        const isSubActive = location.pathname === sub.path;
                        return (
                          <div
                            key={sub.id}
                            className={`ss-submenu-item ${isSubActive ? "ss-active" : ""}`}
                            onClick={() => {
                              storeSelectedScreenOfSellerDashboardSidebar(sub.label);
                              navigate(sub.path);
                            }}
                          >
                            <span className="ss-submenu-dot"></span>
                            <span>{sub.label}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </nav>

          {/* Footer Section */}
          <div className="ss-menu-footer">
            <div
              key={"back-to-store"}
              className="ss-menu-item ss-logout-item"
              onClick={() => navigate("/")}
            >
              <div className="ss-menu-item-content">
                <ShoppingBag size={20} className="ss-menu-icon" />
                <span className="ss-menu-label">Back to Store</span>
              </div>
            </div>
            <div
              key={"logout"}
              className="ss-menu-item ss-logout-item"
              onClick={sellerLogout}
            >
              <div className="ss-menu-item-content">
                <LogOut size={20} className="ss-menu-icon" />
                <span className="ss-menu-label">Log Out</span>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </Container>
  );
};

export default SellerSideBar;